export enum ActionCommand {
  UPGRADE_GNB = "UPGRADEGNB",
  UPGRADE_CN5G = "UPGRADECN5G",
  UPGRADE_OAIBOX = "UPGRADE",
  UPGRADE_FLEXRIC = "UPGRADE",
  UPGRADE_UHD = "UPGRADEUHD",
  UPDATE_LICENSE = "UPDATELICENSE",
}
